import {gql} from '@apollo/client';

export const PILOT_DASHBOARD_OVERVIEW = gql`
  query PilotDashboardOverview($range: PilotDateRangeInput!) {
    pilotDashboardOverview(range: $range) {
      kpi {
        visitors
        identifiedVisitors
        sessions
        events
        leads
        conversionRate
      }
      timeSeries {
        date
        visits
        leads
      }
      sourceBreakdown {
        key
        count
      }
      campaignBreakdown {
        key
        count
      }
      funnel {
        stage
        count
      }
    }
  }
`;

export const PILOT_VISITORS = gql`
  query PilotVisitors(
    $filter: PilotVisitorFilterInput
    $sort: PilotVisitorSortInput
    $limit: Int
    $offset: Int
  ) {
    pilotVisitors(filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
      total
      hasMore
      visitors {
        id
        identity {
          email
          firstName
          lastName
          company
          title
        }
        attribution {
          source
          campaign
          medium
          apolloContactId
          apolloCampaignId
        }
        firstSeenAt
        lastSeenAt
        identifiedAt
        sessionCount
        eventCount
        leadCount
        stage
      }
    }
  }
`;

export const PILOT_VISITOR_DETAIL = gql`
  query PilotVisitorDetail($id: ID!) {
    pilotVisitor(id: $id) {
      id
      identity {
        email
        firstName
        lastName
        company
        title
        linkedinUrl
        phone
      }
      attribution {
        source
        campaign
        medium
        content
        term
        apolloContactId
        apolloCampaignId
      }
      rawParams
      firstSeenAt
      lastSeenAt
      identifiedAt
      sessionCount
      eventCount
      leadCount
      stage
      userAgent
      sessions {
        id
        startedAt
        lastActiveAt
        referrer
        userAgent
        eventCount
      }
      events {
        id
        sessionId
        name
        payload
        occurredAt
      }
      leads {
        id
        kind
        email
        firstName
        lastName
        company
        role
        notes
        roiPayload
        simPayload
        createdAt
      }
    }
  }
`;
